import is from 'is_js';

export function isUnitReport(category) {
  if (is.string(category)) {
    return category.toLowerCase() === 'UnitReport'.toLowerCase();
  }
  return false;
}

export function isProgressReport(category) {
  if (is.string(category)) {
    return category.toLowerCase() === 'ProgressReport'.toLowerCase();
  }
  return false;
}



// WEBPACK FOOTER //
// ./data/Users/Notifications/accessors.js